<template>
    <div class=" col-6 col-xl-3">
        <div class="summary-assignments__item">
            <div class="summary-assignments__user">
                <img :src="getAvatar" class="summary-assignments__avatar">
                <div class="summary-assignments__name">
                    {{ getCommonName }}
                </div>
            </div>
            <div class="summary-assignments__stats row">
                <div class="ado-assignment__stats--item col-12 col-xl-6">
                    <i class="far fa-user-clock fa-2x icon__warning"></i>
                    <div class="ado-assignment__stats-desc">
                        <div class="ado-assignment__stats-title">
                            Assigned
                        </div>
                        <div :class="[ getCountClass, 'ado-assignment__stats-count']">
                            {{ getCount }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'summary-assignments-item',
    props: {
        counsellor: {
            type: Object,
            required: true
        }
    },
    computed: {
        getAvatar() {
            return this.counsellor.avatar.path || '../../../assets/avatar/profile.jpg';
        },
        getCommonName() {
            return this.counsellor.commonName || 'Not available';
        },
        getCount() {
            return this.counsellor.count;
        },
        getCountClass () {
            return this.counsellor.count > 0 ? 'ado-assignment__stats-count--info' : '';
        }
    }
}
</script>

<style scoped>
.summary-assignments__item {
    -webkit-box-shadow: 0px 0px 13px 0px rgba(82, 63, 105, 0.05);
    box-shadow: 0px 0px 13px 0px rgba(82, 63, 105, 0.05);
    background-color: #ffffff;
    margin-bottom: 20px;
    border-radius: 4px;
    padding: 1rem;
}

.summary-assignments__name {
    padding: 0.4rem 0 0.3rem 0;
    font-size: 1rem;
    color: #48465b;
    font-weight: 600;
}

.summary-assignments__stats {
    margin: .75rem 0 0 0;
}

.ado-assignment__stats--item {}

.ado-assignment__stats--item i {
    float: left;
}

.ado-assignment__stats-desc {
    line-height: 18px;
    margin-left: 46px;
}

.ado-assignment__stats-count {
    color: #595d6e;
    font-weight: 500;
    font-size: 16px;
}

.ado-assignment__stats-count--info {
    color: #fd397a;
    font-weight: 600;
}

.ado-assignment__stats-title {
    color: #48465b;
    font-weight: 600;
    font-size: 12px;
}

.summary-assignments__user {
    border-bottom: 1px solid #ebedf2;
    text-align: center;
    width: 100%;
}

.summary-assignments__user img {
    border-radius: 50%;
    height: 48px;
    width: 48px;
    -o-object-fit: cover;
    object-fit: cover;
}
</style>